import type { Dispatch } from 'redux';
import { ff } from '@atlassian/jira-feature-flagging';
import { change } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/filters';
import { clearInlineCreate } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/inline-create';
import {
	HIERARCHY_FILTER_ID,
	HIERARCHY_RANGE_FILTER_ID,
	type HierarchyFilterValue,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onHierarchyChange: (payload: HierarchyFilterValue) => {
		dispatch(clearInlineCreate());
		// delete this condition and keep the truthy case when removing the feature flag
		if (ff('use-jira-hierarchy-levels-in-plans_knftc')) {
			dispatch(
				change({
					id: HIERARCHY_FILTER_ID,
					value: { start: payload.start + 1, end: payload.end + 1 },
				}),
			);
			dispatch(
				change({
					id: HIERARCHY_RANGE_FILTER_ID,
					value: payload,
				}),
			);
		} else {
			dispatch(change({ id: HIERARCHY_FILTER_ID, value: payload }));
			dispatch(
				change({
					id: HIERARCHY_RANGE_FILTER_ID,
					value: { start: payload.start - 1, end: payload.end - 1 },
				}),
			);
		}
	},
});

export default mapDispatchToProps;
